import { getStore } from "../stores/base.js";
import {
  errorMsg,
  getValueFromObject,
  msgData,
  validateAndUpdateVariable
} from "./utils.js";

export const getPageParams = (pageId, data) => {
  try {
    const { key } = data;
    // eslint-disable-next-line no-unused-vars
    const usePageDevStore = getStore(`runtime_page_${pageId}`);
    const pageParams = usePageDevStore.getState().getPageInputs();
    return msgData(data, {
      value: pageParams?.[key]
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const getAllPageParams = (pageId, data) => {
  try {
    // eslint-disable-next-line no-unused-vars
    const usePageDevStore = getStore(`runtime_page_${pageId}`);
    const pageParams = usePageDevStore.getState().getPageInputs();
    return msgData(data, pageParams);
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const openPopup = (pageId, data) => {
  try {
    let { popupId, popupParams } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    let pageMeta = usePageStore.getState().pageMetadata;
    let popupMeta = pageMeta.getObject(popupId);
    if (!popupMeta) {
      return errorMsg(data, { message: `Popup ${popupId} not found` });
    }
    if (popupParams) {
      usePageStore.getState().updatePopupContext(popupId, popupParams);
    }
    usePageStore.getState().pushToPopupList(popupMeta);
  } catch (e) {
    return errorMsg(e);
  }
};

export const closePopup = (pageId) => {
  try {
    let usePageStore = getStore(`runtime_page_${pageId}`);
    usePageStore.getState().dequeuePopup();
  } catch (e) {
    return errorMsg(e);
  }
};

export const getPageVariable = (pageId, data) => {
  try {
    const { key } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    const value = usePageStore.getState().pageVariables[key];
    let result = msgData(data, {
      value
    });
    return result;
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const setPageVariable = (pageId, data) => {
  try {
    const { key, value } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);
    let args = {
      getVariable: (variableName) =>
        usePageStore.getState().pageVariables[variableName],
      setVariable: usePageStore.getState().updatePageVariable
    };
    let resp;

    if (typeof key === "string") {
      resp = validateAndUpdateVariable({
        variableName: key,
        value,
        varDef: usePageStore.getState().getPageVariableDefinition(key),
        ...args
      });
    } else if (typeof key === "object") {
      resp = Object.entries(key).reduce((acc, [key, value]) => {
        let res = validateAndUpdateVariable({
          variableName: key,
          value,
          varDef: usePageStore.getState().getPageVariableDefinition(key),
          ...args
        });

        return { ...acc, ...res };
      }, {});
    }

    return msgData(data, {
      ...resp
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const getPageVariableSync = (pageId, data, atomics) => {
  try {
    let { key, path } = data;
    let usePageStore = getStore(`runtime_page_${pageId}`);

    path.push(key); //added leaf key to the path
    let [variableName, ...restNestedPath] = path;

    const parentValue = usePageStore.getState().pageVariables[variableName];
    const value = getValueFromObject(parentValue, restNestedPath); // get nested value from object

    let response = msgData(data, {
      value
    });
    atomics.store(response);
  } catch (e) {
    let error = errorMsg(data, e);
    atomics.store(error);
  }

  atomics.notify();
  return;
};

export const setPageVariableSync = (pageId, data, atomics) => {
  try {
    let usePageStore = getStore(`runtime_page_${pageId}`);

    let { key, value, path } = data;

    path.push(key);
    let [variableName, ...restNestedPath] = path;

    let updatedValue = validateAndUpdateVariable({
      variableName: variableName,
      value,
      varDef: usePageStore.getState().getPageVariableDefinition(variableName),
      nestedPath: restNestedPath,
      getVariable: (variableName) =>
        usePageStore.getState().pageVariables[variableName],
      setVariable: usePageStore.getState().updatePageVariable
    });

    let response = msgData(data, { ...updatedValue });
    atomics.store(response);
  } catch (e) {
    console.error("page variable set error", e);
    let error = errorMsg(data, e);
    atomics.store(error);
  }

  atomics.notify();
  return;
};
